import { PropertyManagementSystem } from "shared/types/partner";

// Partner/PMS settings booleans can arrive as the strings "true"/"false"
// (legacy /settings path) or as real booleans (credential path). Coerce both.
export const getBoolValue = (
  value: string | boolean | null | undefined
): boolean => value === true || value === "true";

export enum SyncOption {
  NEVER = "never",
  FIRST_SYNC = "first_time",
  EVERY_SYNC = "every"
}

export const SyncOptionLabels = {
  [SyncOption.NEVER]: "Never",
  [SyncOption.FIRST_SYNC]: "Only first sync",
  [SyncOption.EVERY_SYNC]: "Every sync"
};

export const PMSNames: Record<PropertyManagementSystem, string> = {
  [PropertyManagementSystem.Appfolio]: "Appfolio",
  [PropertyManagementSystem.Buildium]: "Buildium",
  [PropertyManagementSystem.RentManager]: "Rent Manager",
  [PropertyManagementSystem.Rentvine]: "Rentvine",
  [PropertyManagementSystem.Resman]: "Resman",
  [PropertyManagementSystem.RentersWarehouse]: "Renters Warehouse",
  [PropertyManagementSystem.ManageAmerica]: "ManageAmerica",
  [PropertyManagementSystem.Entrata]: "Entrata",
  [PropertyManagementSystem.Quext]: "Quext",
  [PropertyManagementSystem.Propertyware]: "Propertyware",
  [PropertyManagementSystem.Revela]: "Revela",
  [PropertyManagementSystem.Yardi]: "Yardi",
  [PropertyManagementSystem.Other]: "Other"
};

export enum IntegrationTab {
  General = "General",
  Credentials = "Credentials",
  AssetStatuses = "Asset statuses",
  // Rent Manager only — Boom lead stage → Rent Manager Prospect stage mapping.
  LeadStage = "Lead Stage"
}

export enum ProspectsCreationOptions {
  Decision = "decision",
  Submission = "submission",
  Start = "start",
  Lead = "lead"
}

export enum GuestCardCreationOptions {
  Lead = "lead",
  ApplicationStarted = "application_started",
  ApplicationSubmitted = "application_submitted"
}
